import { render, staticRenderFns } from "./IpError.vue?vue&type=template&id=1fc49b56&scoped=true"
import script from "./IpError.vue?vue&type=script&lang=js"
export * from "./IpError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc49b56",
  null
  
)

export default component.exports